import { Auth } from "aws-amplify";

export const getLoggedInUserEmail = async () => {
  const user = await Auth.currentAuthenticatedUser();
  const email = user?.attributes?.email;
  if (!email) {
    throw new Error("Unable to resolve logged-in user email.");
  }
  return { email, user };
};

export const getAuthRequestContext = async () => {
  const session = await Auth.currentSession();
  const idToken = session.getIdToken().getJwtToken();
  const { email } = await getLoggedInUserEmail();

  return {
    email,
    headers: {
      Authorization: `Bearer ${idToken}`,
      "Content-Type": "application/json"
    }
  };
};
